module.exports = "section {\n  margin: 25px;\n}\n\nth {\n  text-align: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/financial/account-statement-view/account-statement-view.component.css
// module id = ./src/app/financial/account-statement-view/account-statement-view.component.css
// module chunks = main